/**
 * Metni her kelimenin ilk harfi büyük, diğerleri küçük olacak şekilde biçimlendirir (Türkçe uyumlu).
 * Parantez/rakam ile başlayan kelimelerde ilk harf yine büyük yapılır: "(COCUK)" -> "(Çocuk)"
 * Örn: "SELAM DUNYaLi (58 SivaS)" -> "Selam Dünyalı (58 Sivas)"
 */
export const formatBranchDisplay = (str) => {
    if (str == null || typeof str !== 'string') return str || '';
    const trimmed = str.trim();
    if (!trimmed) return '';
    return trimmed
        .split(/\s+/)
        .map((word) => {
            const lower = word.toLocaleLowerCase('tr-TR');
            if (!lower) return word;
            const firstLetterMatch = lower.match(/\p{L}/u);
            if (!firstLetterMatch) return word;
            const idx = firstLetterMatch.index;
            return lower.slice(0, idx) + lower.charAt(idx).toLocaleUpperCase('tr-TR') + lower.slice(idx + 1);
        })
        .join(' ');
};
